import { PARTNER_URL } from '../lib/constants.js';

export default function Partner() {
  return (
    // No local chrome above the embed: the partner page owns the whole route,
    // so the iframe gets every pixel below the navbar. overflow-y-auto stays
    // for short viewports, where the min-height below would otherwise clip.
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
      {/* The partner page is a client-rendered SPA and needs its own origin for
          assets/API calls, hence allow-scripts + allow-same-origin. Referrer and
          popups stay allowed so registration click-throughs leave the sandbox.
          The frame is absolutely positioned: `height: 100%` alone would collapse
          to the browser's default 300x150 iframe, since the box below is sized by
          min-height (i.e. its own `height` stays auto). */}
      <div className="relative min-h-[420px] flex-1 border-y border-edge bg-coal">
        <iframe
          src={PARTNER_URL}
          title="LS Ball — Strawberry Gas partner page"
          loading="eager"
          referrerPolicy="no-referrer-when-downgrade"
          sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals"
          className="absolute inset-0 h-full w-full border-0"
        />
      </div>
    </div>
  );
}
